const choices_data = [
    {
        "answer": "",
        "correct": true,
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
]

const config = {
    type: 'EVALUATION',
    component: "Sev01",
    portrait: "/img/container/S-EV-01.jpg",
    body: {
        question: "",
        time:'1',
        choices:choices_data
    },
}

export { config }